import React from 'react';
import PropTypes from 'prop-types';
import clx from 'classnames';

export default class SortOrder extends React.Component {
  static propTypes = {
    desc: PropTypes.bool,
  };

  render() {
    const { desc } = this.props;

    const orderClasses = clx({
      'rt-sort-desc': desc,
      'rt-sort-asc': !desc,
    });

    return (
      <div className="rt-sort">
        <div className={orderClasses} />
      </div>
    );
  }
}
